export default __webpack_public_path__ + "static/zenith-1-b3b6015f8300d041e5c2a5342fc915cd.jpg";